import { useEffect, useContext } from 'react';
import { useLocation } from 'react-router-dom';
import { LayoutContext } from '../contexts/LayoutContext';

export default function ScrollToTop() {
  const { pathname } = useLocation();
  const { mainContentRef } = useContext(LayoutContext);

  useEffect(() => {
    if (mainContentRef && mainContentRef.current) {
      mainContentRef.current.scrollTo(0, 0);
    } else {
      window.scrollTo(0, 0);
    }
  }, [pathname, mainContentRef]);

  return null;
}
